const defaultAccountSettings = {
    
accountNbr: "",
startGameOptions: {
    gameTemplateArr: [
      "easyGame",
      "midGame",
      "difficultGame",
      "veryDifficultGame"
    ],
    nbrGames: "2"
  },
  testSettings: {
    testType: "pre-test",
    forceTest: false
  }
}

export default defaultAccountSettings;